import { useState, useEffect } from 'react';
import { FaArrowUp, FaBox, FaClock, FaMoneyBillWave, FaUserSlash, FaMobileAlt, FaCreditCard, FaCheckCircle, FaBullseye, FaSearch, FaFileAlt, FaBuilding, FaTint, FaChartBar, FaDollarSign, FaExclamationTriangle, FaCrosshairs, FaHeart, FaUserTimes, FaChartLine, FaHistory, FaFileInvoiceDollar, FaBalanceScale, FaSkullCrossbones } from 'react-icons/fa';
import NavbarSection from './NavbarSection';
import HeroSection from './HeroSection';
import CourseVideosSection from './CourseVideosSection';
import ProblemsSection from './ProblemsSection';
import AuthorIntroSection from './AuthorIntroSection';
import PrinciplesSection from './PrinciplesSection';
import TestimonialsSection from './TestimonialsSection';
import ContactSection from './ContactSection';
import FooterSection from './FooterSection';

function Course() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [selectedPrinciple, setSelectedPrinciple] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const principles = [
    { num: "01", icon: FaBox, title: "Don't send products in over quantity", desc: "Control quantity for timely payments" },
    { num: "02", icon: FaClock, title: "Stop saying - Karlenge, Dekh lenge", desc: "Don't make empty promises" },
    { num: "03", icon: FaMoneyBillWave, title: "Don't buy products on credit", desc: "Avoid credit chain in business" },
    { num: "04", icon: FaUserSlash, title: "Features of Bad Paying Customer", desc: "Identify risky customers early" },
    { num: "05", icon: FaMobileAlt, title: "How to deal with new customers", desc: "Smart approach for first-time buyers" },
    { num: "06", icon: FaCreditCard, title: "Do not let the debt get old", desc: "Follow up on payments immediately" },
    { num: "07", icon: FaCheckCircle, title: 'How to deal with "C" and "D" category customers', desc: "Strategies for different customer types" },
    { num: "08", icon: FaBullseye, title: "Reverse your payment model", desc: "Change from credit to upfront payment" },
    { num: "09", icon: FaSearch, title: "MSME or UDYAM Registration is mandatory", desc: "Legal protection for your business" },
    { num: "10", icon: FaFileAlt, title: "Get your FDs back", desc: "Recover stuck funds smartly" },
    { num: "11", icon: FaBuilding, title: "Do not take loans & sell goods on credit", desc: "Avoid double debt burden" },
    { num: "12", icon: FaTint, title: "Service charge - INR 500 (New Marketing Strategy)", desc: "Monetize your services effectively" },
    { num: "13", icon: FaChartBar, title: 'Start saying "No" to customers', desc: "Protect your business interests" },
    { num: "14", icon: FaDollarSign, title: "Loan leke udhar maal becha", desc: "Avoid risky payment models" },
    { num: "15", icon: FaExclamationTriangle, title: "Business Loss mein - band kar diya (2 bar)", desc: "Know when to exit gracefully" },
    { num: "16", icon: FaCrosshairs, title: "Do Not Slip Over Sales", desc: "Quality over quantity matters" },
    { num: "17", icon: FaHeart, title: "Always Make Loyal Customers", desc: "Build lasting business relationships" },
    { num: "18", icon: FaUserTimes, title: "Customer Gayab Ho Gaya, Kya Kare", desc: "Strategies for absconding customers" },
    { num: "19", icon: FaChartLine, title: "Failing to Plan = Plan to Fail", desc: "Strategic business planning" },
    { num: "20", icon: FaHistory, title: "Always ask your payments before Time", desc: "Proactive payment collection" },
    { num: "21", icon: FaFileInvoiceDollar, title: "Cheque Bounce is a Good News", desc: "Legal advantage in recovery" },
    { num: "22", icon: FaBalanceScale, title: "Two Laws of Payment Recovery", desc: "Legal frameworks for recovery" },
    { num: "23", icon: FaSkullCrossbones, title: "9 Habits Of Failed Businessman", desc: "Avoid failure patterns" },
  ];

  const testimonials = [
    { name: "Abhishek Gupta", business: "RG Sales - FMCG Modern Trade Distribution, Delhi", text: "Rushneek Sir, I feel so blessed to find you. I don't think I have ever seen anyone who is so giving and so unselfish. People like you keep this world still livable. God Bless You!" },
    { name: "Sumit Patel", business: "ALLIANCE ELEMECH - Mfg of Sterilizer Machine, Ahmedabad", text: "There are many Coaches in the Market who keep motivating people but you are different From All of them. You help your participants both personally and professionally! Your style and method is very effective." },
    { name: "Rakesh Agarwal", business: "FURNITURE DOST - Raipur (C.G)", text: "My life would not be the same without Rushneek Singh as my coach. Apse jo gyan mil raha hai woh sach mein anmol hai! Main shabdon me usey bta nahi skta. Love u sir from bottom of my heart!" },
    { name: "Aditya Agarwal", business: "Designs World - Karol Bagh, New Delhi", text: "He has helped me improve not only the quality of clients in my practice, but also the quantity of money they provide me. Today I have 40% alpha customers & 60% are Beta. But my sales are 60% to alpha!" },
  ];

  const handlePrincipleClick = (principle) => {
    setSelectedPrinciple(principle);
  };

  const closeModal = () => {
    setSelectedPrinciple(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-blue-50 to-sky-50">
      <NavbarSection isScrolled={isScrolled} />

      <HeroSection />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <CourseVideosSection />
        <ProblemsSection />
        <AuthorIntroSection />
        <PrinciplesSection 
          principles={principles}
          onPrincipleClick={handlePrincipleClick}
          selectedPrinciple={selectedPrinciple}
          onCloseModal={closeModal}
        />
        <TestimonialsSection testimonials={testimonials} />
        <ContactSection />
      </main>

      {/* <FooterSection /> */}

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 z-40 w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg hover:-translate-y-1 hover:shadow-xl transition-all duration-300 ${
          showScrollTop ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <FaArrowUp className="w-5 h-5 text-white" />
      </button>
    </div>
  );
}

export default Course;
